import React, { Component } from 'react';
import { path } from 'ramda';

import Scenario from './Scenario';
import { CMD, OBJTYPE } from 'constants/scenario';
import { getToken } from 'utils/token';

export default class ScenarioView extends Component {
    render() {
        const params = {
            objkey: Number(path(['match', 'params', 'id'], this.props)),
            cmd: CMD,
            objtype: OBJTYPE,
            token: getToken(),
        };

        return (
            <Scenario params={params} />
        );
    }
}
